import React from "react";
import {Toast} from "@shopify/polaris";

const ToasterToggle = ({toastmessage,toastactive,isErrorMessage}) =>{
    return(
        isErrorMessage ? <Toast content={toastmessage} error onDismiss={toastactive} /> :  <Toast content={toastmessage} onDismiss={toastactive} /> 
    );
}

export default ToasterToggle;